module.exports = __webpack_public_path__ + "assets/992902378169af67f6dc7d8a37356557.png";